import { render } from "./register-stepper-company.vue?vue&type=template&id=09633eca&scoped=true&ts=true"
import script from "./register-stepper-company.vue?vue&type=script&lang=ts"
export * from "./register-stepper-company.vue?vue&type=script&lang=ts"

import "./register-stepper-company.vue?vue&type=style&index=0&id=09633eca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09633eca"]])

export default __exports__